export const setFilterExpression = (filter, name, operand1, operand2, operator) => {
    filter[name] = {
        operand1,
        operand2,
        operator
    };
}

export const setFilter = (query, name, value, operator = 'equals', setExpression, value2 = null) => {
    if (!query)
        return null;
    if (!query.filter)
        query.filter = {};

    if (value != null && value != undefined) {
        if (!setExpression) {
            setFilterExpression(query.filter, name, value, value2, operator);
        } else {
            setExpression(query.filter, name, value, operator);
        }
    } else {
        query.filter[name] = null;
    }

    return query;
}

export const getFilterValue = (filter, key) => {    
    const path = extractPath(filter, key);
    filter = path.obj;
    key = path.lastPath;
    return filter[key];
}

export const setFilterValue = (filter, key, value) => {
    const path = extractPath(filter, key);
    filter = path.obj;
    key = path.lastPath;
    filter[key] = value;
}

function extractPath(obj, path) {
    if (path && path.indexOf(".") >= 0) {
        const tokens = path.split(".");
        if (!obj[tokens[0]]) {
            obj[tokens[0]] = {};
        }
        obj = obj[tokens[0]];
        path = tokens[1];
    }

    return {
        obj,
        lastPath: path
    };
}

export const allQuery = (query) => {
    if (query) {
        return {
            ...query,
            paging: {
                ...query.paging,
                skip: undefined,
                take: undefined
            }
        }
    }

    return {
        paging: { skip: 0 }
    }
}


export const singleQuery = (query) => {
    if (query) {
        return {
            ...query,
            paging: {
                ...query.paging,
                skip: 0,
                take: 1
            }
        }
    }

    return {
        paging: { skip: 0, take: 1 }
    }
}

export const hasFilter = (query) => {
    if (!query || !query.filter) {
        return false;
    }

    let memberCount = 0;

    for (var key in query.filter) {
        memberCount++;
    }

    return memberCount > 0;
}

export const cloneSort = (sort) => {
    const result = {};

    for (var key in sort) {
        const item = sort[key];

        if (!item) {
            continue;
        }

        result[key] = {
            operator: item.operator,
            ordinal: item.ordinal
        }
    }

    return result;
}

export const setLastQuery = (id, query) => {
    id += 'Query';

    if (!query) {
        return;
    }

    localStorage.setItem(id, JSON.stringify(query));
}

export const getLastQuery = (id, initialQuery) => {
    id += 'Query';

    const queryString = localStorage.getItem(id);
    let query = queryString ? JSON.parse(queryString) : null;

    if (!query) {
        return initialQuery;
    }

    if (initialQuery) {
        query = { ...initialQuery, ...query };
    }

    return query;
}


export const join = (path1, path2) => {
    return (path1 || "") + (path2 || "");
}

export const extract = (path1, path2, data) => {
    const path = join(path1, path2);

    const tokens = path.split('.');
    let result = data;

    if (tokens.length == 1)
        return result[path];

    for (let i = 0; i < tokens.length; i++) {
        const token = tokens[i];

        result = result[token];
        if (!result)
            return result;
    }

    return result;
}

export const inject = (path1, path2, data, value) => {
    const path = join(path1, path2);

    const tokens = path.split('.');
    let parent = data;

    if (tokens.length == 1) {
        parent[path] = value;
        return;
    }

    for (let i = 0; i < tokens.length - 1; i++) {
        const token = tokens[i];

        const previous = parent;
        parent = parent[token];
        if (!parent) {
            const obj = {};
            previous[token] = obj;
            parent = obj;
        }
    }

    parent[tokens[tokens.length - 1]] = value;
}

export const remove = (path1, path2, data) => {
    const path = join(path1, path2);

    const tokens = path.split('.');
    
    if (tokens.length == 0)
        return;

    delete data[tokens[0]];
}